import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component'
import { useSelector } from 'react-redux'
import { LoginInterface } from '../../Interfaces/LoginInterface'
import { AppointmentFinancialInputModel } from '../../models/InputModels/AppointmentFinancialInputModel'
import { LoadingFit, PageHeader } from '../../share/Components'
import { Button, Icon } from '../../share/Elements'
import { ReducerType } from '../../storeManager/ReducerType'
import { RaytebRequests } from '../../_services'
import useFetch from '../../_services/fetch'
import DateFilter from './Items/DateFilter'
import classes from './FinancialReport.module.scss'

const columns = [
  {
    name: 'بیمار',
    selector: (row) => row.patientName,
    sortable: true,
  },
  {
    name: 'نوبت',
    selector: (row) => row.visitDate,
    sortable: true,
  },
  {
    name: 'بیمه',
    selector: (row) => row.insuranceName,
    sortable: true,
  },
  {
    name: 'خدمت',
    selector: (row) => row.serveTitle,
    sortable: true,
  },
  {
    name: 'سهم بیمار',
    selector: (row) => row.patientShare.currency().toPersian(),
    sortable: true,
  },
  {
    name: 'سهم بیمه',
    selector: (row) => row.insuranceShare.currency().toPersian(),
    sortable: true,
  },
  // {
  //   name: "سرویس",
  //   selector: (row) => row.serviceShare.currency().toPersian(),
  //   sortable: true,
  // },
  {
    name: 'جمع کل',
    selector: (row) => row.totalPatientPayed.currency().toPersian(),
    sortable: true,
  },
]

const FinancialReport = () => {
  const [report, setReport] = useState<AppointmentFinancialViewModel>()
  const { Mobile, Desktop, Tablet, Laptop } = useSelector<
    ReducerType,
    DeviceModeInterface
  >((state) => state.reducerDevice)

  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )

  const { isLoading, reFetch } = useFetch<
    AppointmentFinancialViewModel,
    unknown,
    AppointmentFinancialInputModel
  >({
    request: RaytebRequests.Report_Finantial_GET({
      headers: { centerId: center.id },
      token: user.token,
    }),
    onSuccess(data) {
      setReport(data)
    },
  })
  const calculateReport = useFetch<unknown>({
    request: RaytebRequests.Report_CalculateFinancials_GET({
      headers: { centerId: center.id },
      token: user.token,
    }),
    onSuccess(data) {},
  })
  const dateFilter = useSelector<ReducerType, DateFilterViewModel>(
    (state) => state.reducerDateFilter
  )
  useEffect(() => {
    reFetch(null, { ToDate: dateFilter?.to, FromDate: dateFilter?.from })
  }, [dateFilter]) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <LoadingFit
        isLoading={isLoading || calculateReport.isLoading}
      ></LoadingFit>
      <div className={classes['report-dashboard']}>
        <div className={classes.filters}>
          <DateFilter />
        </div>
        <div className={classes.abstract}>
          <div className={'col-span-3'}>
            <div className='text-primaryLight'>
              <span>کل:</span>
              <span className='font-bold pr-1'>
                {report?.total.toString().toPersian()}
              </span>
            </div>
            <div className='text-primaryLight'>
              <span>مبلغ پرداختی بیمار:</span>
              <span className='font-bold pr-1'>
                {report?.sumTotalPatientPayed!.currency().toPersian()}
              </span>
            </div>
            <div className='text-primaryLight'>
              <span>سهم بیمه:</span>
              <span className='font-bold pr-1'>
                {report?.sumInsuranceShare!.currency().toPersian()}
              </span>
            </div>
          </div>
          <button
            className={
              'mr-auto relative  flex h-[50px] w-40 items-center justify-center overflow-hidden bg-secondary text-white  transition-all before:absolute before:h-0 before:w-0 before:rounded-full before:bg-secondaryLight before:duration-500 before:ease-out  hover:before:h-56 hover:before:w-56'
            }
            onClick={() => {
              calculateReport.reFetch()
            }}
          >
            <span className='relative z-10'>محاسبه</span>
          </button>
        </div>

        {Mobile ? (
          <>
            <div className='bg-white rounded p-2'>
              {report?.items.map((n, i) => (
                <div
                  className='shadow-sm grid grid-cols-2 gap-3  items-center p-5 my-3'
                  key={i}
                >
                  <div className='col-span-2'>
                    <span className=''>{n.patientName} - </span>
                    <span className={`text-[11px]`}> {n.patientCode}</span>
                  </div>
                  <div className='margin-right: auto; text-[12px] text-secondary mr-auto'>
                    {n.visitDate}
                  </div>
                  <div className='col-span-3 text-[12px]'>
                    {n.insuranceName}
                  </div>
                  <div className='col-span-3 text-[12px] text-secondary'>
                    {n.serveTitle}
                  </div>
                  <DetailInfo
                    title='سهم بیمار'
                    value={n.totalPatientPayed.currency().toPersian()}
                  ></DetailInfo>
                  <DetailInfo
                    title='سهم بیمه'
                    value={n.insuranceShare.currency().toPersian()}
                  ></DetailInfo>
                  <DetailInfo
                    title='سهم سرویس'
                    value={n.serviceShare.currency().toPersian()}
                  ></DetailInfo>
                </div>
              ))}
            </div>
          </>
        ) : (
          <>
            <DataTable
              columns={columns}
              data={report?.items!}
              pagination
              paginationComponentOptions={{ rowsPerPageText: '' }}
              noDataComponent={''}
            />
          </>
        )}
      </div>
    </>
  )
}
const DetailInfo = ({
  title,
  value,
  className,
  isEdit,
  editOption,
  isOpen,
  onClose,
  onShow,
}: {
  title: string
  value: any
  className?: string
  isEdit?: boolean
  editOption?: TextBoxInterface
  isOpen?: boolean
  onClose?: () => void
  onShow?: () => void
}) => {
  return (
    <>
      <div
        className={`border-x-2 border-primaryLight/50  rounded-md 
                px-4 py-2 flex flex-col justify-center
               items-center relative ${className ?? ''}`}
        style={{ direction: 'initial' }}
      >
        {isOpen ? (
          <>
            <div
              className='absolute -top-36 flex justify-center  items-center flex-col z-[96]
           bg-primaryDefault2'
            >
              <div className='flex justify-center items-center px-6 gap-10 w-full py-3 sticky top-full'>
                <Button
                  type='submit'
                  className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-6 !shadow-lg'
                >
                  <Icon icon='rayteb-android-done' />
                </Button>
                <Button
                  onClick={() => onClose?.()}
                  className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-6 !shadow-lg'
                >
                  <Icon icon='rayteb-android-close' />
                </Button>
              </div>
            </div>
            <Icon
              icon='rayteb-arrow-down-b'
              className='absolute -top-9 bottom-0 text-3xl animate-ping h-10 w-10 text-warnDark'
            />
          </>
        ) : (
          ''
        )}
        <span className='absolute -top-3 text-xs text-primary'>{title}</span>
        <span
          onClick={() => onShow?.()}
          className={`text-center text-xs ${
            isEdit
              ? 'underline decoration-primary decoration-dashed underline-offset-8'
              : ''
          }`}
        >
          {value}
        </span>
      </div>
    </>
  )
}
export default FinancialReport
